import React, { useState } from "react";
import { connect } from "react-redux";
import { Mutation } from "react-apollo";

import { ROLE_SYSTEM_ADMINISTRATOR } from "../../../security/role";
import registerForTrainingUnitMutation from "../../../gql/registerForTrainingUnitMutation";
import { toastTranslated } from "../../../toastr/toastr";
import transError from "../../../i18n/fieldError";
import RegisterButton from "./RegisterButton";
import SuccessModal from "./SuccessModal";
import ConfirmationModal from "./ConfirmationModal";

function RegisterContainer({
  trainingUnit,
  memberId,
  myRole,
  myAccountId,
  onFinished
}) {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [waitingListPosition, setWaitingListPosition] = useState(false);
  const registrationMemberId = memberId ? memberId : myAccountId;

  const willBeWaitingList = trainingUnit.potentialWaitingListPosition > 0;

  const handleRegister = mutateFunc => () => {
    mutateFunc({
      variables: {
        registration: {
          trainingUnitId: trainingUnit.id,
          memberId: registrationMemberId
        }
      }
    }).then(({ data: { result } }) => {
      if (result.error) {
        result.error.errors.forEach(error => {
          toastTranslated(
            "error",
            transError(`registration.${error.code}`, error.arguments)
          );
        });

        return;
      }

      setWaitingListPosition(result.waitingListPosition);
      setShowConfirmationModal(false);
      setShowSuccessModal(true);
    });
  };

  const closeSuccessModal = () => {
    if (onFinished) {
      onFinished();
    }

    setShowSuccessModal(false);
  };

  const closeConfirmationModal = () => {
    if (onFinished) {
      onFinished();
    }

    setShowConfirmationModal(false);
  };

  return (
    <Mutation mutation={registerForTrainingUnitMutation} ignoreResults={false}>
      {mutateFunc => (
        <>
          <RegisterButton
            onSubmit={() => setShowConfirmationModal(true)}
            canRegister={trainingUnit.canRegister}
            cannotRegisterReason={trainingUnit.canNotRegisterCause}
            willBeWaitingList={willBeWaitingList}
            isAdmin={myRole === ROLE_SYSTEM_ADMINISTRATOR}
          />
          {showConfirmationModal && (
            <ConfirmationModal
              trainingUnit={trainingUnit}
              willBeWaitingList={willBeWaitingList}
              onConfirm={handleRegister(mutateFunc)}
              onClose={closeConfirmationModal}
            />
          )}
          {showSuccessModal && (
            <SuccessModal
              trainingUnit={trainingUnit}
              waitingListPosition={waitingListPosition}
              onClose={closeSuccessModal}
            />
          )}
        </>
      )}
    </Mutation>
  );
}

RegisterContainer.displayName = "coursePlan/register/RegisterContainer";

const mapStateToProps = ({ auth: { accountId, role } }) => ({
  myRole: role,
  myAccountId: accountId
});

export default connect(mapStateToProps)(React.memo(RegisterContainer));
